import type { AxiosRequestConfig } from 'axios';

import { axiosInstance } from '../axios-instance';
import type { AuditLogExportFormat } from './auditExportNotInOpenApiClient';

type RequestOptions = AxiosRequestConfig | undefined;

export type AccessReviewExportFormat = AuditLogExportFormat;

export interface AccessReviewListQueryParams {
  page?: number;
  pageSize?: number;
  /** Defaults to true on the BE when omitted. */
  deviantsOnly?: boolean;
  databaseName?: string;
  permissionSnapshotId?: number;
  dateFrom?: string;
  dateTo?: string;
}

export interface AccessReviewExportBody {
  usernames?: string[];
  excludedUsernames?: string[];
  databaseName?: string | null;
  deviantsOnly?: boolean;
  permissionSnapshotId?: number | null;
  dateFrom?: string | null;
  dateTo?: string | null;
}

/**
 * Omitted from published OpenAPI until TROC-352 BE is in the vendored spec.
 * GET list + summary; POST export blob (`format=csv|xlsx`, same as Audit).
 *
 * TROC-286: BE export manifest should include **Deviates from template** (Yes/No) and database
 * columns; FE does not redefine export columns client-side.
 */
export const getApiUserManagementV1AccessReview = (
  params: AccessReviewListQueryParams,
  options?: RequestOptions,
  signal?: AbortSignal
) => {
  return axiosInstance(
    {
      url: '/api/user-management/v1/access-review',
      method: 'GET',
      params,
      signal
    },
    options
  );
};

export const postApiUserManagementV1AccessReviewExport = (
  body: AccessReviewExportBody,
  format: AccessReviewExportFormat = 'xlsx',
  options?: RequestOptions,
  signal?: AbortSignal
) => {
  return axiosInstance<Blob>(
    {
      url: '/api/user-management/v1/access-review/export',
      method: 'POST',
      params: { format },
      data: body,
      responseType: 'blob',
      signal
    },
    options
  );
};
